import React from "react";
import { Row } from "./Row/Row";
import styles from "./Table.module.scss";

export const Table: React.FC = ({ rows, handleItem, item }) => {
  if (rows.length <= 0) {
    return "";
  }
  return (
    <table className={styles.table}>
      <thead>
        <tr>
          <td>Название записи</td>
          <td>Дата изменения</td>
          <td></td>
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <Row key={row.id} row={row} handleItem={handleItem} item={item} />
        ))}
      </tbody>
    </table>
  );
};
